import PropTypes from 'prop-types';
import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import styles from './RoleFilterResetButton.module.scss';

const RoleFilterResetButton = ({ onFiltersReset, filterList, disable }) => {
  const isFilterActive = filterList;

  return (
    <Button
      disabled={!isFilterActive || disable}
      className={styles.resetFiltersButton}
      bsStyle="link"
      onClick={() => onFiltersReset()}
    >
      Clear
    </Button>
  );
};

RoleFilterResetButton.propTypes = {
  onFiltersReset: PropTypes.func,
  filterList: PropTypes.string,
};

export default RoleFilterResetButton;
